import { KpState, UserState } from '@/@types/store/state';
import auth from '@/helpers/auth';

import { User } from '@/models/User';
import { ActionContext } from 'vuex';

export default {
    namespaced: true,
    state: {
        error: null,
        record: null,
    } as UserState,
    mutations: {
        setUser(state: UserState, user: User | null) {
            state.record = User.fromData(user) as User;
        },
        setError(state: UserState, error: string | null) {
            state.error = error;
        },
    },
    actions: {
        /**
         * Executes a login request. Returns the user
         * object when successful, or sets an error if not.
         */
        async loginTry(context: ActionContext<UserState, KpState>, data: { username: string; password: string }) {
            context.commit('loading', true, { root: true });
            context.commit('setError', null);
            let user = null;
            let pwChange = false;
            try {
                const loginResponse = await auth.login(data.username, data.password);
                if (loginResponse.user) {
                    user = User.fromData(loginResponse.user);
                }
                pwChange = loginResponse.password_change === true;
            } catch (err: any) {
                context.commit('setError', String(err.message || err));
            }
            context.commit('loading', false, { root: true });
            return { user, pwChange };
        },

        /**
         * Logs out the user and sets the user state to null.
         */
        async logout(context: ActionContext<UserState, KpState>) {
            context.commit('loading', true, { root: true });
            try {
                await auth.logout();
                context.commit('setUser', null);
                document.location.reload();
            } catch (err: any) {
                context.commit('setError', String(err.message || err));
            }
            context.commit('loading', false, { root: true });
        },
    },
};
